import { Multimedia } from '@web/shared/module/multimedia';
import { AdminBrandBannerStatus } from '@web/shared/module/brand';
import { Guid, Nillable } from '@web/utils';

export class AdminBrandBannerCollectionItem {
  public constructor(
    private readonly data: {
      canBeEdited: boolean;
      canBeRemoved: boolean;
      canBeViewed: boolean;
      createdAt: Nillable<Date>;
      file: Multimedia;
      id: Guid;
      status: AdminBrandBannerStatus;
      url?: Nillable<string>;
      visibilityEndDate?: Nillable<Date>;
      visibilityStartDate?: Nillable<Date>;
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get status(): AdminBrandBannerStatus {
    return this.data.status;
  }

  public get url(): Nillable<string> {
    return this.data.url;
  }

  public get createdAt(): Nillable<Date> {
    return this.data.createdAt;
  }

  public get file(): Multimedia {
    return this.data.file;
  }

  public get visibilityStartDate(): Nillable<Date> {
    return this.data.visibilityStartDate;
  }

  public get visibilityEndDate(): Nillable<Date> {
    return this.data.visibilityEndDate;
  }

  public get canBeViewed(): boolean {
    return this.data.canBeViewed;
  }

  public get canBeEdited(): boolean {
    return this.data.canBeEdited;
  }

  public get canBeRemoved(): boolean {
    return this.data.canBeRemoved;
  }
}
